import * as i0 from '@angular/core';
import { inject, ChangeDetectorRef, DestroyRef, ElementRef, EventEmitter, Output, Input, ViewEncapsulation, ChangeDetectionStrategy, Component, NgZone, Injector, afterNextRender, ViewChild, ViewContainerRef, Renderer2, DOCUMENT, numberAttribute, booleanAttribute, NgModule } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i4 from 'ng-zorro-antd/core/outlet';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import * as i2 from 'ng-zorro-antd/core/trans-button';
import { NzTransButtonModule } from 'ng-zorro-antd/core/trans-button';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import * as i3 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';
import * as i1 from 'ng-zorro-antd/tooltip';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { ESCAPE, ENTER } from '@angular/cdk/keycodes';
import { BehaviorSubject, Subscription } from 'rxjs';
import { switchMap, first } from 'rxjs/operators';
import { fromEventOutsideAngular, isStyleSupport, measure } from 'ng-zorro-antd/core/util';
import * as i1$1 from 'ng-zorro-antd/input';
import { NzInputModule, NzAutosizeDirective } from 'ng-zorro-antd/input';
import { __esDecorate, __runInitializers } from 'tslib';
import { Directionality } from '@angular/cdk/bidi';
import { Platform } from '@angular/cdk/platform';
import { NgTemplateOutlet } from '@angular/common';
import { WithConfig, NzConfigService } from 'ng-zorro-antd/core/config';
import { cancelAnimationFrame, requestAnimationFrame } from 'ng-zorro-antd/core/polyfill';
import { NzResizeService } from 'ng-zorro-antd/core/services';

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
function NzTextCopyComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "nz-icon", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const icon_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzType", icon_r1);
  }
}
const _c0 = ["textarea"];
function NzTextEditComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "textarea", 2, 0);
    i0.ɵɵlistener("blur", function NzTextEditComponent_Conditional_0_Template_textarea_blur_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.confirm());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 3);
    i0.ɵɵlistener("click", function NzTextEditComponent_Conditional_0_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.confirm());
    });
    i0.ɵɵelement(3, "nz-icon", 4);
    i0.ɵɵelementEnd();
  }
}
function NzTextEditComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "nz-icon", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const icon_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzType", icon_r4);
  }
}
function NzTextEditComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function NzTextEditComponent_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClick());
    });
    i0.ɵɵtemplate(1, NzTextEditComponent_Conditional_1_ng_container_1_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("nzTooltipTitle", ctx_r1.tooltip === null ? null : ctx_r1.tooltip || (ctx_r1.locale == null ? null : ctx_r1.locale.edit));
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r1.icon);
  }
}
const _c1 = ["ellipsisContainer"];
const _c2 = ["expandable"];
const _c3 = ["contentTemplate"];
const _c4 = ["*"];
const _c5 = a0 => ({
  content: a0
});
function NzTypographyComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function NzTypographyComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, NzTypographyComponent_ng_template_0_Conditional_0_Template, 1, 0);
    i0.ɵɵtext(1);
  }
  if (rf & 2) {
    const content_r1 = ctx.content;
    i0.ɵɵconditional(!content_r1 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", content_r1, " ");
  }
}
function NzTypographyComponent_Conditional_2_Conditional_0_ng_template_0_Template(rf, ctx) {}
function NzTypographyComponent_Conditional_2_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.nzSuffix, " ");
  }
}
function NzTypographyComponent_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzTypographyComponent_Conditional_2_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 5);
    i0.ɵɵconditionalCreate(1, NzTypographyComponent_Conditional_2_Conditional_0_Conditional_1_Template, 1, 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const contentTemplate_r3 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", contentTemplate_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c5, ctx_r1.nzContent));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.nzSuffix ? 1 : -1);
  }
}
function NzTypographyComponent_Conditional_2_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.ellipsisStr, " ");
  }
}
function NzTypographyComponent_Conditional_2_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.nzSuffix, " ");
  }
}
function NzTypographyComponent_Conditional_2_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7, 2);
    i0.ɵɵlistener("click", function NzTypographyComponent_Conditional_2_Conditional_1_Conditional_4_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onExpand());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.locale == null ? null : ctx_r1.locale.expand, " ");
  }
}
function NzTypographyComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", null, 1);
    i0.ɵɵconditionalCreate(2, NzTypographyComponent_Conditional_2_Conditional_1_Conditional_2_Template, 1, 1);
    i0.ɵɵconditionalCreate(3, NzTypographyComponent_Conditional_2_Conditional_1_Conditional_3_Template, 1, 1);
    i0.ɵɵconditionalCreate(4, NzTypographyComponent_Conditional_2_Conditional_1_Conditional_4_Template, 3, 1, "a", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.isEllipsis ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.nzSuffix ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.nzExpandable && ctx_r1.isEllipsis ? 4 : -1);
  }
}
function NzTypographyComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, NzTypographyComponent_Conditional_2_Conditional_0_Template, 2, 5)(1, NzTypographyComponent_Conditional_2_Conditional_1_Template, 5, 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.expanded || !ctx_r1.hasOperationsWithEllipsis && ctx_r1.nzEllipsisRows === 1 && !ctx_r1.hasEllipsisObservers || ctx_r1.canCssEllipsis || ctx_r1.nzSuffix && ctx_r1.expanded ? 0 : 1);
  }
}
function NzTypographyComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-text-edit", 8);
    i0.ɵɵlistener("endEditing", function NzTypographyComponent_Conditional_3_Template_nz_text_edit_endEditing_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEndEditing($event));
    })("startEditing", function NzTypographyComponent_Conditional_3_Template_nz_text_edit_startEditing_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onStartEditing());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", ctx_r1.nzContent)("icon", ctx_r1.nzEditIcon)("tooltip", ctx_r1.nzEditTooltip);
  }
}
function NzTypographyComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-text-copy", 9);
    i0.ɵɵlistener("textCopy", function NzTypographyComponent_Conditional_4_Template_nz_text_copy_textCopy_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onTextCopy($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", ctx_r1.copyText)("tooltips", ctx_r1.nzCopyTooltips)("icons", ctx_r1.nzCopyIcons);
  }
}
let NzTextCopyComponent = /*#__PURE__*/(() => {
  class NzTextCopyComponent {
    cdr = inject(ChangeDetectorRef);
    clipboard = inject(Clipboard);
    i18n = inject(NzI18nService);
    destroyRef = inject(DestroyRef);
    copied = false;
    copyId;
    locale;
    nativeElement = inject(ElementRef).nativeElement;
    copyTooltip = null;
    copedTooltip = null;
    copyIcon = 'copy';
    copedIcon = 'check';
    text;
    tooltips;
    icons = ['copy', 'check'];
    textCopy = new EventEmitter();
    constructor() {
      this.destroyRef.onDestroy(() => {
        clearTimeout(this.copyId);
      });
    }
    ngOnInit() {
      this.i18n.localeChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.locale = this.i18n.getLocaleData('Text');
        this.updateTooltips();
        this.cdr.markForCheck();
      });
    }
    ngOnChanges(changes) {
      const {
        tooltips,
        icons
      } = changes;
      if (tooltips) {
        this.updateTooltips();
      }
      if (icons) {
        this.updateIcons();
      }
    }
    onClick() {
      if (this.copied) {
        return;
      }
      this.copied = true;
      this.cdr.detectChanges();
      const text = this.text;
      this.textCopy.emit(text);
      this.clipboard.copy(text);
      this.onCopied();
    }
    onCopied() {
      clearTimeout(this.copyId);
      this.copyId = setTimeout(() => {
        this.copied = false;
        this.cdr.detectChanges();
      }, 3000);
    }
    updateTooltips() {
      if (this.tooltips === null) {
        this.copedTooltip = null;
        this.copyTooltip = null;
      } else if (Array.isArray(this.tooltips)) {
        const [copyTooltip, copedTooltip] = this.tooltips;
        this.copyTooltip = copyTooltip || this.locale?.copy;
        this.copedTooltip = copedTooltip || this.locale?.copied;
      } else {
        this.copyTooltip = this.locale?.copy;
        this.copedTooltip = this.locale?.copied;
      }
      this.cdr.markForCheck();
    }
    updateIcons() {
      const [copyIcon, copedIcon] = this.icons;
      this.copyIcon = copyIcon;
      this.copedIcon = copedIcon;
      this.cdr.markForCheck();
    }
    static ɵfac = function NzTextCopyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTextCopyComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTextCopyComponent,
      selectors: [["nz-text-copy"]],
      inputs: {
        text: "text",
        tooltips: "tooltips",
        icons: "icons"
      },
      outputs: {
        textCopy: "textCopy"
      },
      exportAs: ["nzTextCopy"],
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 4,
      consts: [["type", "button", "nz-tooltip", "", "nz-trans-button", "", 1, "ant-typography-copy", 3, "click", "nzTooltipTitle"], [4, "nzStringTemplateOutlet"], [3, "nzType"]],
      template: function NzTextCopyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵlistener("click", function NzTextCopyComponent_Template_button_click_0_listener() {
            return ctx.onClick();
          });
          i0.ɵɵtemplate(1, NzTextCopyComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("ant-typography-copy-success", ctx.copied);
          i0.ɵɵproperty("nzTooltipTitle", ctx.copied ? ctx.copedTooltip : ctx.copyTooltip);
          i0.ɵɵadvance();
          i0.ɵɵproperty("nzStringTemplateOutlet", ctx.copied ? ctx.copedIcon : ctx.copyIcon);
        }
      },
      dependencies: [NzToolTipModule, i1.NzTooltipDirective, NzTransButtonModule, i2.NzTransButtonDirective, NzIconModule, i3.NzIconDirective, NzOutletModule, i4.NzStringTemplateOutletDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTextCopyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTextEditComponent = /*#__PURE__*/(() => {
  class NzTextEditComponent {
    ngZone = inject(NgZone);
    cdr = inject(ChangeDetectorRef);
    i18n = inject(NzI18nService);
    destroyRef = inject(DestroyRef);
    editing = false;
    locale;
    text;
    icon = 'edit';
    tooltip;
    startEditing = new EventEmitter();
    endEditing = new EventEmitter(true);
    set textarea(textarea) {
      this.textarea$.next(textarea);
    }
    autosizeDirective;
    beforeText;
    currentText;
    nativeElement = inject(ElementRef).nativeElement;
    // We could've saved the textarea within some private property (e.g. `_textarea`) and have a getter,
    // but having subject makes the code more reactive and cancellable (e.g., event listeners will be
    // automatically removed and re-added through the `switchMap` below).
    textarea$ = new BehaviorSubject(null);
    injector = inject(Injector);
    ngOnInit() {
      this.i18n.localeChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.locale = this.i18n.getLocaleData('Text');
        this.cdr.markForCheck();
      });
      this.textarea$.pipe(switchMap(textarea => fromEventOutsideAngular(textarea?.nativeElement, 'keydown')), takeUntilDestroyed(this.destroyRef)).subscribe(event => {
        // Caretaker note: adding modifier at the end (for instance `(keydown.esc)`) will tell Angular to add
        // an event listener through the `KeyEventsPlugin`, which always runs `ngZone.runGuarded()` internally.
        // We're interested only in escape and enter keyboard buttons, otherwise Angular will run change detection
        // on any `keydown` event.
        if (event.keyCode !== ESCAPE && event.keyCode !== ENTER) {
          return;
        }
        this.ngZone.run(() => {
          if (event.keyCode === ESCAPE) {
            this.onCancel();
          } else {
            this.onEnter(event);
          }
          this.cdr.markForCheck();
        });
      });
      this.textarea$.pipe(switchMap(textarea => fromEventOutsideAngular(textarea?.nativeElement, 'input')), takeUntilDestroyed(this.destroyRef)).subscribe(event => {
        this.currentText = event.target.value;
      });
    }
    onClick() {
      this.beforeText = this.text;
      this.currentText = this.beforeText;
      this.editing = true;
      this.startEditing.emit();
      this.focusAndSetValue();
    }
    confirm() {
      this.editing = false;
      this.endEditing.emit(this.currentText);
    }
    onEnter(event) {
      event.stopPropagation();
      event.preventDefault();
      this.confirm();
    }
    onCancel() {
      this.currentText = this.beforeText;
      this.confirm();
    }
    focusAndSetValue() {
      const {
        injector
      } = this;
      afterNextRender(() => {
        this.textarea$.pipe(
        // It may still not be available, so we need to wait until view queries
        // are executed during the change detection. It's safer to wait until
        // the query runs, and the textarea is set on the behavior subject.
        first(textarea => textarea != null), takeUntilDestroyed(this.destroyRef)).subscribe(textarea => {
          textarea.nativeElement.focus();
          textarea.nativeElement.value = this.currentText || '';
          this.autosizeDirective.resizeToFitContent();
          this.cdr.markForCheck();
        });
      }, {
        injector
      });
    }
    static ɵfac = function NzTextEditComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTextEditComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTextEditComponent,
      selectors: [["nz-text-edit"]],
      viewQuery: function NzTextEditComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(NzAutosizeDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textarea = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autosizeDirective = _t.first);
        }
      },
      inputs: {
        text: "text",
        icon: "icon",
        tooltip: "tooltip"
      },
      outputs: {
        startEditing: "startEditing",
        endEditing: "endEditing"
      },
      exportAs: ["nzTextEdit"],
      decls: 2,
      vars: 1,
      consts: [["textarea", ""], ["nz-tooltip", "", "nz-trans-button", "", 1, "ant-typography-edit", 3, "nzTooltipTitle"], ["nz-input", "", "nzAutosize", "", 3, "blur"], ["nz-trans-button", "", 1, "ant-typography-edit-content-confirm", 3, "click"], ["nzType", "enter"], ["nz-tooltip", "", "nz-trans-button", "", 1, "ant-typography-edit", 3, "click", "nzTooltipTitle"], [4, "nzStringTemplateOutlet"], [3, "nzType"]],
      template: function NzTextEditComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵconditionalCreate(0, NzTextEditComponent_Conditional_0_Template, 4, 0)(1, NzTextEditComponent_Conditional_1_Template, 2, 2, "button", 1);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.editing ? 0 : 1);
        }
      },
      dependencies: [NzInputModule, i1$1.NzInputDirective, i1$1.NzAutosizeDirective, NzTransButtonModule, i2.NzTransButtonDirective, NzIconModule, i3.NzIconDirective, NzToolTipModule, i1.NzTooltipDirective, NzOutletModule, i4.NzStringTemplateOutletDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTextEditComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NZ_CONFIG_MODULE_NAME = 'typography';
const EXPAND_ELEMENT_CLASSNAME = 'ant-typography-expand';
let NzTypographyComponent = (() => {
  let _nzCopyTooltips_decorators;
  let _nzCopyTooltips_initializers = [];
  let _nzCopyTooltips_extraInitializers = [];
  let _nzCopyIcons_decorators;
  let _nzCopyIcons_initializers = [];
  let _nzCopyIcons_extraInitializers = [];
  let _nzEditTooltip_decorators;
  let _nzEditTooltip_initializers = [];
  let _nzEditTooltip_extraInitializers = [];
  let _nzEditIcon_decorators;
  let _nzEditIcon_initializers = [];
  let _nzEditIcon_extraInitializers = [];
  let _nzEllipsisRows_decorators;
  let _nzEllipsisRows_initializers = [];
  let _nzEllipsisRows_extraInitializers = [];
  return class NzTypographyComponent {
    static {
      const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
      _nzCopyTooltips_decorators = [WithConfig()];
      _nzCopyIcons_decorators = [WithConfig()];
      _nzEditTooltip_decorators = [WithConfig()];
      _nzEditIcon_decorators = [WithConfig()];
      _nzEllipsisRows_decorators = [WithConfig()];
      __esDecorate(null, null, _nzCopyTooltips_decorators, {
        kind: "field",
        name: "nzCopyTooltips",
        static: false,
        private: false,
        access: {
          has: obj => "nzCopyTooltips" in obj,
          get: obj => obj.nzCopyTooltips,
          set: (obj, value) => {
            obj.nzCopyTooltips = value;
          }
        },
        metadata: _metadata
      }, _nzCopyTooltips_initializers, _nzCopyTooltips_extraInitializers);
      __esDecorate(null, null, _nzCopyIcons_decorators, {
        kind: "field",
        name: "nzCopyIcons",
        static: false,
        private: false,
        access: {
          has: obj => "nzCopyIcons" in obj,
          get: obj => obj.nzCopyIcons,
          set: (obj, value) => {
            obj.nzCopyIcons = value;
          }
        },
        metadata: _metadata
      }, _nzCopyIcons_initializers, _nzCopyIcons_extraInitializers);
      __esDecorate(null, null, _nzEditTooltip_decorators, {
        kind: "field",
        name: "nzEditTooltip",
        static: false,
        private: false,
        access: {
          has: obj => "nzEditTooltip" in obj,
          get: obj => obj.nzEditTooltip,
          set: (obj, value) => {
            obj.nzEditTooltip = value;
          }
        },
        metadata: _metadata
      }, _nzEditTooltip_initializers, _nzEditTooltip_extraInitializers);
      __esDecorate(null, null, _nzEditIcon_decorators, {
        kind: "field",
        name: "nzEditIcon",
        static: false,
        private: false,
        access: {
          has: obj => "nzEditIcon" in obj,
          get: obj => obj.nzEditIcon,
          set: (obj, value) => {
            obj.nzEditIcon = value;
          }
        },
        metadata: _metadata
      }, _nzEditIcon_initializers, _nzEditIcon_extraInitializers);
      __esDecorate(null, null, _nzEllipsisRows_decorators, {
        kind: "field",
        name: "nzEllipsisRows",
        static: false,
        private: false,
        access: {
          has: obj => "nzEllipsisRows" in obj,
          get: obj => obj.nzEllipsisRows,
          set: (obj, value) => {
            obj.nzEllipsisRows = value;
          }
        },
        metadata: _metadata
      }, _nzEllipsisRows_initializers, _nzEllipsisRows_extraInitializers);
      if (_metadata) Object.defineProperty(this, Symbol.metadata, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: _metadata
      });
    }
    _nzModuleName = NZ_CONFIG_MODULE_NAME;
    nzConfigService = inject(NzConfigService);
    el = inject(ElementRef).nativeElement;
    cdr = inject(ChangeDetectorRef);
    viewContainerRef = inject(ViewContainerRef);
    renderer = inject(Renderer2);
    platform = inject(Platform);
    i18n = inject(NzI18nService);
    resizeService = inject(NzResizeService);
    directionality = inject(Directionality);
    document = inject(DOCUMENT);
    destroyRef = inject(DestroyRef);
    nzCopyable = false;
    nzEditable = false;
    nzDisabled = false;
    nzExpandable = false;
    nzEllipsis = false;
    nzCopyTooltips = __runInitializers(this, _nzCopyTooltips_initializers, undefined);
    nzCopyIcons = (__runInitializers(this, _nzCopyTooltips_extraInitializers), __runInitializers(this, _nzCopyIcons_initializers, ['copy', 'check']));
    nzEditTooltip = (__runInitializers(this, _nzCopyIcons_extraInitializers), __runInitializers(this, _nzEditTooltip_initializers, undefined));
    nzEditIcon = (__runInitializers(this, _nzEditTooltip_extraInitializers), __runInitializers(this, _nzEditIcon_initializers, 'edit'));
    nzContent = __runInitializers(this, _nzEditIcon_extraInitializers);
    nzEllipsisRows = __runInitializers(this, _nzEllipsisRows_initializers, 1);
    nzType = __runInitializers(this, _nzEllipsisRows_extraInitializers);
    nzCopyText;
    nzSuffix;
    nzContentChange = new EventEmitter();
    nzCopy = new EventEmitter();
    nzExpandChange = new EventEmitter();
    // This is not a two-way binding output with {@link nzEllipsis}
    nzOnEllipsis = new EventEmitter();
    textEditRef;
    textCopyRef;
    ellipsisContainer;
    expandableBtn;
    contentTemplate;
    locale;
    expandableBtnElementCache = null;
    editing = false;
    ellipsisText;
    cssEllipsis = false;
    isEllipsis = true;
    expanded = false;
    ellipsisStr = '...';
    dir = 'ltr';
    get hasEllipsisObservers() {
      return this.nzOnEllipsis.observers.length > 0;
    }
    get canCssEllipsis() {
      return this.nzEllipsis && this.cssEllipsis && !this.expanded && !this.hasEllipsisObservers;
    }
    get hasOperationsWithEllipsis() {
      return (this.nzCopyable || this.nzEditable || this.nzExpandable) && this.nzEllipsis;
    }
    viewInit = false;
    requestId = -1;
    windowResizeSubscription = Subscription.EMPTY;
    get copyText() {
      return typeof this.nzCopyText === 'string' ? this.nzCopyText : this.nzContent;
    }
    constructor() {
      this.destroyRef.onDestroy(() => {
        this.expandableBtnElementCache = null;
        this.windowResizeSubscription.unsubscribe();
      });
    }
    onTextCopy(text) {
      this.nzCopy.emit(text);
    }
    onStartEditing() {
      this.editing = true;
    }
    onEndEditing(text) {
      this.editing = false;
      this.nzContentChange.emit(text);
      if (this.nzContent === text) {
        this.renderOnNextFrame();
      }
      this.cdr.markForCheck();
    }
    onExpand() {
      this.isEllipsis = false;
      this.expanded = true;
      this.nzExpandChange.emit();
      this.nzOnEllipsis.emit(false);
    }
    canUseCSSEllipsis() {
      if (this.nzEditable || this.nzCopyable || this.nzExpandable || this.nzSuffix) {
        return false;
      }
      // make sure {@link nzOnEllipsis} works, will force use JS to calculations
      if (this.hasEllipsisObservers) {
        return false;
      }
      if (this.nzEllipsisRows === 1) {
        return isStyleSupport('textOverflow');
      } else {
        return isStyleSupport('webkitLineClamp');
      }
    }
    renderOnNextFrame() {
      cancelAnimationFrame(this.requestId);
      if (!this.viewInit || !this.nzEllipsis || this.nzEllipsisRows < 0 || this.expanded || !this.platform.isBrowser) {
        return;
      }
      this.requestId = requestAnimationFrame(() => this.syncEllipsis());
    }
    getOriginContentViewRef() {
      const viewRef = this.viewContainerRef.createEmbeddedView(this.contentTemplate, {
        content: this.nzContent
      });
      viewRef.detectChanges();
      return {
        viewRef,
        removeView: () => this.viewContainerRef.remove(this.viewContainerRef.indexOf(viewRef))
      };
    }
    syncEllipsis() {
      if (this.cssEllipsis) {
        return;
      }
      const {
        viewRef,
        removeView
      } = this.getOriginContentViewRef();
      const fixedNodes = [this.textCopyRef, this.textEditRef].filter(e => e && e.nativeElement).map(e => e.nativeElement);
      const expandableBtnElement = this.getExpandableBtnElement();
      if (expandableBtnElement) {
        fixedNodes.push(expandableBtnElement);
      }
      const {
        contentNodes,
        text,
        ellipsis
      } = measure(this.el, this.nzEllipsisRows, viewRef.rootNodes, fixedNodes, this.ellipsisStr, this.nzSuffix);
      removeView();
      this.ellipsisText = text;
      if (ellipsis !== this.isEllipsis) {
        this.isEllipsis = ellipsis;
        this.nzOnEllipsis.emit(ellipsis);
      }
      const ellipsisContainerNativeElement = this.ellipsisContainer.nativeElement;
      while (ellipsisContainerNativeElement.firstChild) {
        this.renderer.removeChild(ellipsisContainerNativeElement, ellipsisContainerNativeElement.firstChild);
      }
      contentNodes.forEach(n => {
        this.renderer.appendChild(ellipsisContainerNativeElement, n.cloneNode(true));
      });
      this.cdr.markForCheck();
    }
    // Need to create the element for calculation size before view init
    getExpandableBtnElement() {
      if (this.nzExpandable) {
        const expandText = this.locale ? this.locale.expand : '';
        const cache = this.expandableBtnElementCache;
        if (!cache || cache.innerText === expandText) {
          const el = this.document.createElement('a');
          el.className = EXPAND_ELEMENT_CLASSNAME;
          el.innerText = expandText;
          this.expandableBtnElementCache = el;
        }
        return this.expandableBtnElementCache;
      } else {
        this.expandableBtnElementCache = null;
        return null;
      }
    }
    renderAndSubscribeWindowResize() {
      if (this.platform.isBrowser) {
        this.windowResizeSubscription.unsubscribe();
        this.cssEllipsis = this.canUseCSSEllipsis();
        this.renderOnNextFrame();
        this.windowResizeSubscription = this.resizeService.connect().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.renderOnNextFrame());
      }
    }
    ngOnInit() {
      this.i18n.localeChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.locale = this.i18n.getLocaleData('Text');
        this.cdr.markForCheck();
      });
      this.directionality.change?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(direction => {
        this.dir = direction;
        this.cdr.detectChanges();
      });
      this.dir = this.directionality.value;
    }
    ngAfterViewInit() {
      this.viewInit = true;
      this.renderAndSubscribeWindowResize();
    }
    ngOnChanges(changes) {
      const {
        nzCopyable,
        nzEditable,
        nzExpandable,
        nzEllipsis,
        nzContent,
        nzEllipsisRows,
        nzSuffix
      } = changes;
      if (nzCopyable || nzEditable || nzExpandable || nzEllipsis || nzContent || nzEllipsisRows || nzSuffix) {
        if (this.nzEllipsis) {
          if (this.expanded) {
            this.windowResizeSubscription.unsubscribe();
          } else {
            this.renderAndSubscribeWindowResize();
          }
        }
      }
    }
    static ɵfac = function NzTypographyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTypographyComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTypographyComponent,
      selectors: [["nz-typography"], ["", "nz-typography", ""], ["p", "nz-paragraph", ""], ["span", "nz-text", ""], ["h1", "nz-title", ""], ["h2", "nz-title", ""], ["h3", "nz-title", ""], ["h4", "nz-title", ""]],
      viewQuery: function NzTypographyComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(NzTextEditComponent, 5);
          i0.ɵɵviewQuery(NzTextCopyComponent, 5);
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
          i0.ɵɵviewQuery(_c3, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textEditRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textCopyRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ellipsisContainer = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expandableBtn = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentTemplate = _t.first);
        }
      },
      hostVars: 26,
      hostBindings: function NzTypographyComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("-webkit-line-clamp", ctx.canCssEllipsis && ctx.nzEllipsisRows > 1 ? ctx.nzEllipsisRows : null);
          i0.ɵɵclassProp("ant-typography", !ctx.editing)("ant-typography-rtl", ctx.dir === "rtl")("ant-typography-edit-content", ctx.editing)("ant-typography-secondary", ctx.nzType === "secondary")("ant-typography-warning", ctx.nzType === "warning")("ant-typography-danger", ctx.nzType === "danger")("ant-typography-success", ctx.nzType === "success")("ant-typography-disabled", ctx.nzDisabled)("ant-typography-ellipsis", ctx.nzEllipsis && !ctx.expanded)("ant-typography-single-line", ctx.nzEllipsis && ctx.nzEllipsisRows === 1)("ant-typography-ellipsis-single-line", ctx.canCssEllipsis && ctx.nzEllipsisRows === 1)("ant-typography-ellipsis-multiple-line", ctx.canCssEllipsis && ctx.nzEllipsisRows > 1);
        }
      },
      inputs: {
        nzCopyable: [2, "nzCopyable", "nzCopyable", booleanAttribute],
        nzEditable: [2, "nzEditable", "nzEditable", booleanAttribute],
        nzDisabled: [2, "nzDisabled", "nzDisabled", booleanAttribute],
        nzExpandable: [2, "nzExpandable", "nzExpandable", booleanAttribute],
        nzEllipsis: [2, "nzEllipsis", "nzEllipsis", booleanAttribute],
        nzCopyTooltips: "nzCopyTooltips",
        nzCopyIcons: "nzCopyIcons",
        nzEditTooltip: "nzEditTooltip",
        nzEditIcon: "nzEditIcon",
        nzContent: "nzContent",
        nzEllipsisRows: [2, "nzEllipsisRows", "nzEllipsisRows", numberAttribute],
        nzType: "nzType",
        nzCopyText: "nzCopyText",
        nzSuffix: "nzSuffix"
      },
      outputs: {
        nzContentChange: "nzContentChange",
        nzCopy: "nzCopy",
        nzExpandChange: "nzExpandChange",
        nzOnEllipsis: "nzOnEllipsis"
      },
      exportAs: ["nzTypography"],
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c4,
      decls: 5,
      vars: 3,
      consts: [["contentTemplate", ""], ["ellipsisContainer", ""], ["expandable", ""], [3, "text", "icon", "tooltip"], [3, "text", "tooltips", "icons"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ant-typography-expand"], [1, "ant-typography-expand", 3, "click"], [3, "endEditing", "startEditing", "text", "icon", "tooltip"], [3, "textCopy", "text", "tooltips", "icons"]],
      template: function NzTypographyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, NzTypographyComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵconditionalCreate(2, NzTypographyComponent_Conditional_2_Template, 2, 1);
          i0.ɵɵconditionalCreate(3, NzTypographyComponent_Conditional_3_Template, 1, 3, "nz-text-edit", 3);
          i0.ɵɵconditionalCreate(4, NzTypographyComponent_Conditional_4_Template, 1, 3, "nz-text-copy", 4);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!ctx.editing ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.nzEditable ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.nzCopyable && !ctx.editing ? 4 : -1);
        }
      },
      dependencies: [NgTemplateOutlet, NzTextEditComponent, NzTextCopyComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  };
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTypographyModule = /*#__PURE__*/(() => {
  class NzTypographyModule {
    static ɵfac = function NzTypographyModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTypographyModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NzTypographyModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [NzTypographyComponent, NzTextCopyComponent, NzTextEditComponent]
    });
  }
  return NzTypographyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzTextCopyComponent, NzTextEditComponent, NzTypographyComponent, NzTypographyModule };
